export interface Party {
  key: string;
  name: string;
}

export const parties = {
  D: 'Democrat',
  R: 'Republican',
  L: 'Libertarian',
  G: 'Green',
  I: 'Independent',
  N: 'Nonpartisan',
  C: 'Constitution',
  ASP: 'American Solidarity Party',
  W: 'We The People',
  P: 'Populist',
  NL: 'No Labels',
  S: 'Socialist Party',
  F: 'Forward',
  CP: 'Conservative Party',
  WFP: 'Working Families',
  PF: 'People First',
  LR: 'LaRouche Party'
}